module.exports = __webpack_public_path__ + "312d93e60f4a373bf2c64fd0894ec6c7.png";